// extracted by mini-css-extract-plugin
export var container = "teamPhoto-module--container--CQx6V";
export var teamPhoto = "teamPhoto-module--teamPhoto--+HGQl";